<template>
  <div>

    <TitlePage :title="$t('transactions')"></TitlePage>

    <v-row class="align-center">
      <v-col cols="12" md="12">
        <ItemActions :selected="selected" :edit-permission="false" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile class="filter-card">
      <v-row class="px-4 pt-3 align-center">
        <v-col cols="12" md="3">
          <v-text-field
              v-model="filter.code"
              :label="$t('code') + ' ' + $t('booking')"
              clearable dense outlined hide-details
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-select
              :items="statuses"
              label="Stato"
              item-text="text" item-value="value"
              v-model="filter.status"
              clearable dense outlined hide-details
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
              v-model="filter.customer_q"
              :label="$t('customer') + ' (Nome/Cognome – mittente)'"
              clearable dense outlined hide-details
          />
        </v-col>
      </v-row>

      <v-row class="px-4 pb-3 align-center">
        <v-col cols="12" md="6">
          <DateRangeQuick
              v-model="createdFilter"
              :label="$t('creation_date')"
              @change="onCreatedChange"
          />
        </v-col>

        <v-spacer />

        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilter">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>


    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.booking_code="{ item }">
          <router-link target="_blank" rel="noopener"
              v-if="item.booking_id"
              :to="`/bookings/edit/${item.booking_id}`"
              blank
          >
            <strong>{{ item.booking_code }}</strong>
          </router-link>
          <strong v-else>{{ item.booking_code }}</strong>
        </template>

        <template v-slot:item.sender_name="{ item }">
          <span v-if="item.sender && item.sender[0]">
            <template v-if="isSuperAdmin">
              <router-link target="_blank" rel="noopener"
                                       v-if="item.sender[0]._id"
                                       :to="`/customers/details/${item.sender[0]._id}`"
                          >
              <strong>{{ item.sender[0].name }} {{ item.sender[0].surname }}</strong>
              </router-link>
            </template>
            <template v-else>
              {{ item.sender[0].name }} {{ item.sender[0].surname }}
            </template>
          </span>
          <span v-else>—</span>
        </template>

        <template v-slot:item.sender_type="{ item }">
          {{ getActor(item.sender_type)}}
        </template>

        <template v-slot:item.receiver_type="{ item }">
          {{ getActor(item.receiver_type)}}
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip small :color="getStatus(item.status, 'color')">{{ getStatus(item.status, 'name') }}</v-chip>
        </template>

        <template v-slot:item.amount="{ item }">
          {{item.amount.toFixed(2)}} €
        </template>

        <template v-slot:item.created_at="{ item }">
          {{new Date(item.created_at).toLocaleString()}}
        </template>

        <template v-slot:item.updated_at="{ item }">
          {{new Date(item.updated_at).toLocaleString()}}
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>

    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import DateRangeQuick from "@/components/filters/DateRangeQuick.vue";

const exportService = require('@/services/export')

export default {
  name: 'Transactions',
  components: {DateRangeQuick, ItemActions, ModalDelete, TitlePage, CenterAutocomplete},
  data() {
    return {
      pathCreate: '/transactions/create/',
      pathEdit: '/transactions/edit/',
      search: '',
      selected: [],
      headers: [
        { text: this.$t('code'),            value: 'booking_code',  sortable: false },
        { text: this.$t('customer'),        value: 'sender_name',   sortable: false },
        { text: this.$t('sender'),          value: 'sender_type',   sortable: false },
        { text: this.$t('receiver'),        value: 'receiver_type', sortable: false },
        { text: this.$t('status'),          value: 'status',        sortable: false },
        { text: this.$t('amount'),          value: 'amount',        sortable: false },
        { text: this.$t('creation_date'),   value: 'created_at' },
        // { text: this.$t('update_date'),  value: 'updated_at' },   // opzionale: rimuovi se serve spazio
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      statuses: [
        {text: "", value: ""},
        {text: "Completata", value: "completed"},
        {text: "Da pagare", value: "to_be_payed"},
        {text: "Cancellata", value: "canceled"},
        {text: "Rimborsata", value: "refunded"},
        {text: "Interrotta", value: "interrupted"},
        {text: "In Attesa", value: "pending"},
      ],
      filter: {
        code: null,
        status: null,
        customer_q: null,
        created_from: null,
        created_to: null
      },
      createdFilter: { from: null, to: null },
      _debouncedSearch: null,
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100]
    };
  },
  async created(){
    this.filter = Object.assign({ code:null, status:null, customer_q:null, created_from:null, created_to:null }, this.getFilter || {});
    this.options_pagination = Object.assign({}, this.getOptionsPagination);
    this._debouncedSearch = this.debounce(async () => { await this.makeSearch(true); }, 350);
    if(!this.filter.created_from && !this.filter.created_to){
      await this.makeSearch(true);
    }
  },
  watch: {
    'filter.code':       function(){ this._debouncedSearch(); },
    'filter.status':     function(){ this._debouncedSearch(); },
    'filter.customer_q': function(){ this._debouncedSearch(); },
  },
  computed: {
    ...mapGetters({
      'getFilter':'transactions/getFilter',
      'getOptionsPagination':'transactions/getOptionsPagination',
      'getUser':'user/getUser'
    }),
    isSuperAdmin(){
      return (this.getUser && this.getUser.super_admin) ? this.getUser.super_admin : false;
    },
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'transactions/index',
      'deleteItem': 'transactions/delete',
      'massiveDeleteItem': 'transactions/massDelete',
      'setFilter': 'transactions/setFilter',
      'setOptionsPagination': 'transactions/setOptionsPagination',
    }),

    debounce(fn, wait){ let t=null; return function(){ const c=this,a=arguments; clearTimeout(t); t=setTimeout(()=>fn.apply(c,a), wait); }; },
    onCreatedChange(payload){
      this.filter.created_from = payload.from;
      this.filter.created_to   = payload.to;
      this._debouncedSearch();
    },
    async resetFilter(){
      this.filter = { code:null, status:null, customer_q:null, created_from:null, created_to:null };
      this.createdFilter = { from:null, to:null };
      this.options_pagination = { page:1, limit:10 };
      await this.makeSearch(true);
    },

    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      var results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.remove(mode)
      }else if(this.typeDelete == 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async getNewPage(){
      await this.makeSearch()
    },
    getStatus(status, type) {
      switch (status) {
        case "completed":
          return (type == 'name') ? 'Completata' : 'success'
        case "booked":
          return (type == 'name') ? 'Prenotato' : 'primary'
        case "to_be_payed":
          return (type == 'name') ? 'Da Pagare' : 'info'
        case "canceled":
        case "refunded":
          return (type == 'name') ? 'Annullata' : 'error'
        case "interrupted":
          return (type == 'name') ? 'Interrotta' : 'warning'
        case "pending":
          return (type == 'name') ? 'In attesa' : 'info'
        default:
          return (type == 'name') ? status : 'info'
      }
    },
    calculatePagination(count, limit){

      var divide = (count / limit)
      var rest = divide % 1

      if(rest > 0){
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },
    async setCenterId(id){
      this.filter.center_id = id
    },
    getActor(actor){
      switch (actor) {
        case 'platform':
          return 'Piattaforma'
        case 'customer':
          return 'Utente'
        case 'center':
          return 'Centro Sportivo'
        default:
          return ''
      }
    },
    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
  },
  mounted() {

  },
}
</script>
